import Crud from './crud'
var crud = new Crud('bill_products', 'chi tiết phiếu xuất');

const state = {
    ...crud.state,
    selected: {OrderID: 0}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};